import React from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';

const WeekDays = ({ weekNumbers, dayNames, startDay }) => {
  const haystack = range(7);
  return (
    <div className="r-row r-head">
      {weekNumbers && <div className="r-cell r-weeknum">wn</div>}

      {renderDays(haystack, dayNames, startDay)}
    </div>
  );
};

const renderDays = (haystack, dayNames, startDay) =>
  haystack.map((item, i) => (
    <div key={String(i)} className="r-cell">
      {dayNames[(startDay + i) % 7]}
    </div>
  ));

WeekDays.propTypes = {
  weekNumbers: PropTypes.bool,
  dayNames: PropTypes.array,
  startDay: PropTypes.number,
};

export default WeekDays;



// WEBPACK FOOTER //
// ./src/components/Calendar/WeekDays.js